import { Inject, Injectable } from '@angular/core';
import {
  ProductGroup,
  ProductGroupRepository,
  ProductRepository,
  VariantRepository
} from '@infrab4a/connect';
import { ConnectRequest } from 'src/app/models';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ShopProductGroupService extends BaseConnectService<ProductGroup> {
  constructor(
    @Inject('ProductGroupRepository')
    private productGroupRepository: ProductGroupRepository,
    @Inject('ProductRepository')
    private productRepository: ProductRepository,
    @Inject('VariantRepository')
    private variantRepository: VariantRepository
  ) {
    super(productGroupRepository);
  }

  async getPaginatedList(request: Partial<ConnectRequest>) {
    const result = await this.paginatedSearch(request);
    const content = result.data.map((group) => ({ ...group }));
    const totalPages = request.pageSize
      ? Math.floor(result.count / request.pageSize)
      : undefined;
    const totalElements = result.count;

    return {
      totalPages,
      totalElements,
      content,
      empty: result.count === 0
    };
  }

  async getList() {
    const result = await this.productGroupRepository.find({
      orderBy: {
        id: 'asc'
      }
    });

    return result.data.map((group) => ({ ...group }));
  }

  async getProductGroupById(id: string): Promise<ProductGroup> {
    return this.productGroupRepository.get({ id });
  }

  async getAllProductsFromGroup(id: string): Promise<any> {
    const fields = ['id', 'sku', 'EAN', 'name', 'brand', 'groupId', 'price'];

    const products = await this.productRepository
      .find({
        fields: fields as any,
        filters: {
          groupId: +id
        },
        orderBy: {
          sku: 'asc'
        }
      })
      .then((res) => res.data);

    const variants = await this.variantRepository
      .find({
        fields: [...fields, 'productId'] as any,
        filters: {
          groupId: +id
        },
        orderBy: {
          sku: 'asc'
        }
      })
      .then((res) => res.data);

    return [...products, ...variants].sort((a, b) =>
      a.sku.localeCompare(b.sku)
    );
  }

  async update(groupId: string, data: Partial<ProductGroup>) {
    return this.productGroupRepository.update(
      ProductGroup.toInstance({ id: groupId, ...data })
    );
  }

  async create(data: Partial<ProductGroup>) {
    return this.productGroupRepository.create(
      ProductGroup.toInstance({ ...data })
    );
  }

  async getPaginatedPriceLogs(request: Partial<ConnectRequest>) {
    const result = await this.paginatedSearch(request);
    const content = result.data.map((group) => ({ ...group }));
    const totalPages = request.pageSize
      ? Math.floor(result.count / request.pageSize)
      : undefined;
    const totalElements = result.count;

    return {
      totalPages,
      totalElements,
      content,
      empty: result.count === 0
    };
  }
}
